import { format } from 'date-fns';
import i18next from 'i18next';
import { DateFormats } from 'src/constants/dateFormats';

export const getDayString = (day: number): string => {
  const days = [
    i18next.t('common:monday'),
    i18next.t('common:tuesday'),
    i18next.t('common:wednesday'),
    i18next.t('common:thursday'),
    i18next.t('common:friday'),
    i18next.t('common:saturday'),
    i18next.t('common:sunday'),
  ];
  return day ? days[day] : null;
};

export const getTimestamp = (): number => {
  return Date.now();
};

export const formatTime = (
  hours: number,
  minutes: number,
  seconds: number
): string => {
  return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(
    -2
  )}:${`0${seconds}`.slice(-2)}`;
};

export const formatDate = (
  dateString: string,
  dateFormat: DateFormats
): string => {
  // Nothing is provided
  if (!dateString) return '';
  const date = Date.parse(dateString);
  // Not a valid date string is provided
  if (!date) return '';

  return format(date, dateFormat);
};
